import React from 'react';
import Model from './Model';
import Input from './Input';
import { cleanRef, isEmpty, isNotEmpty } from '../../lib/ep';




const KeyPair = ({ model, change, ...props }) => {
	const deleteField = () => {
		if(isNotEmpty(model, 'k') || isNotEmpty(model, 'v')) return;

		props.dynamicDispatch({
			type:'DELETE',
			id:model.id,
		});
	};

	const addField = () => {
		if(isEmpty(model, 'k')) return;

		props.dynamicDispatch({
			type:'ADDFIELDAFTER',
			field_type:'kv_pair',
			id:model.id,
		});
	};

	const infer_key = props?.infer_key ?? false; 


	const change_value = (k,v) => {
		
		if (infer_key && k =='v') {
			if (model?.v == undefined || cleanRef(model.v) == model.k) {
				change('k', cleanRef(v));
			}
		}
		change(k,v);
	}

	return (
		<Model
			model={model}
			change={change_value}
		>
			<Input
				name="v"
				onKeyAction={{ key:'Backspace', action:deleteField }}
				autofocus={true}
				placeholder="Value"
				_class={{ first:true }}
			/>

			<Input
				name="k"
				onKeyAction={{ key:'Enter', action:addField }}
				placeholder="Key"
				_class={{ first:true }}
			/>
		</Model>
	)
};
export default KeyPair;